
import { defineComponent, reactive } from 'vue';
import Icone from '@/core/components/Icone.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { useModalBase } from '@/core/composables/ModalBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';

export default defineComponent({
  name: 'ImprimirEtiquetasProdutosModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
    produtos: {
      type: Object as () => number[],
      required: true,
    },
  },
  emits: ['update:visivel', 'exibirPdf'],
  components: {
    Icone,
    RequisicaoModal,
  },
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta, apresentarMensagemErro } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);

    const servicoProduto = new ServicoProduto();

    const state = reactive({
      tipoEtiqueta: 'padrao' as 'padrao' | 'semPreco',
      qtdPorLinha: 3,
    });

    async function imprimir() {
      if (!props.produtos || props.produtos.length === 0) {
        apresentarMensagemAlerta('Nenhum produto selecionado para impressão!');
        return;
      }

      apresentarBarraProgresso('Gerando etiquetas...');
      const semPreco = state.tipoEtiqueta === 'semPreco';
      const retorno = await servicoProduto.imprimirEtiquetasEmMassa(props.produtos, props.empresa, semPreco, state.qtdPorLinha);
      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        emit('exibirPdf', retorno.link);
        modalBase.computedVisivel = false;
      } else if (retorno.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retorno.mensagem);
      } else {
        // apresentarRetornoRequisicao(retorno);
      }
    }

    return {
      telaBase,
      modalBase,
      state,
      props,
      imprimir,
    };
  },
});
